module.exports = __webpack_public_path__ + "img/strategy_mw.2b122886.svg";